import ListAssignedUsers from "./ListAssignedUsers";

function AssignedUsers() {
  return <ListAssignedUsers />;
}

export default AssignedUsers;
